import { render, staticRenderFns } from "./PromoCodeReport.vue?vue&type=template&id=67983b5d&scoped=true"
import script from "./PromoCodeReport.vue?vue&type=script&lang=js"
export * from "./PromoCodeReport.vue?vue&type=script&lang=js"
import style0 from "./PromoCodeReport.vue?vue&type=style&index=0&id=67983b5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67983b5d",
  null
  
)

export default component.exports